'use client';

import React, { useState } from 'react';

import { Justify, Modal, ModalBody, ModalSize, Section, TrilogyColor, View } from '@bytel/trilogy-react';

import { ProductChildFull } from '@app-types/product';

import { Loader } from '@components/loader';

import { getPreorderEresaUrl, getStoreLocatorEresaUrl } from '@product-detail/helpers';

type ModalStoreAvailabilityProps = {
    campaignId: string;
    currentProduct: ProductChildFull;
    onClose: () => void;
};

export function ModalStoreAvailability({ campaignId, currentProduct, onClose }: Readonly<ModalStoreAvailabilityProps>) {
    const [isLoading, setIsLoading] = useState(true);

    return (
        <Modal
            active
            onClose={onClose}
            title={isLoading ? 'Chargement de la liste des boutiques...' : undefined}
            size={ModalSize.LARGE}
        >
            <ModalBody>
                {isLoading && (
                    <Section backgroundColor={TrilogyColor.BACKGROUND}>
                        <View justify={Justify.CENTER} flexable>
                            <Loader />
                        </View>
                    </Section>
                )}
                <iframe
                    src={
                        currentProduct?.stockDetails?.isPreresa
                            ? getPreorderEresaUrl(currentProduct.gencode, campaignId)
                            : getStoreLocatorEresaUrl(currentProduct.gencode)
                    }
                    title='Liste des boutiques'
                    allow='geolocation'
                    onLoad={() => setIsLoading(false)}
                    style={{
                        height: '100%',
                        minHeight: '60vh',
                        width: '100%',
                    }}
                />
            </ModalBody>
        </Modal>
    );
}
